import { SET_USER_SUBSCRIPTION_MODAL } from "./actionType";
export const setUserSubscriptionModal = (userSubscriptionModel) => {
    return {
        type: SET_USER_SUBSCRIPTION_MODAL,
        userSubscriptionModel
    };
};
